import useTrackEvent from "@/hooks/useTrackEvent";

// Wrapper that gives a callback function that triggers events
const EventTracker = ({
  children,
  name,
  properties,
}: {
  children:
    | JSX.Element
    | (({ triggerEvent }: { triggerEvent: () => void }) => JSX.Element);
  name: string;
  properties?: Record<string, any>;
}) => {
  //

  const trackEvent = useTrackEvent();

  const triggerEvent = () => {
    trackEvent({ name, properties });
  };

  if (typeof children === "function") {
    return children({
      triggerEvent,
    });
  }

  return children;
};

export default EventTracker;
